import { CommonModule, NgOptimizedImage } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppLayoutDefaultComponent } from './default.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import {
  MatDrawer,
  MatDrawerContainer,
  MatSidenavModule,
} from '@angular/material/sidenav';
import { MatIcon } from '@angular/material/icon';
import { MatAnchor, MatButton, MatIconButton } from '@angular/material/button';
import { AppLayoutDefaultSideDirective } from './default-side.directive';

@NgModule({
  declarations: [AppLayoutDefaultComponent, AppLayoutDefaultSideDirective],
  imports: [
    CommonModule,
    RouterModule,
    MatToolbarModule,
    NgOptimizedImage,
    MatDrawerContainer,
    MatDrawer,
    MatIcon,
    MatIconButton,
    MatSidenavModule,
    MatButton,
    MatAnchor,
  ],
})
export class AppLayoutDefaultModule {}
